module.exports = __webpack_public_path__ + "img/filterArrowOpen.a6b49b26.png";